<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <recargo-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import RecargoProvider from "../../../providers/RecargoProvider";
    
    import {CrudUpdate} from '@dracul/common-frontend'
import ClientError from "@/errors/ClientError";
    
    import RecargoForm from "../RecargoForm";
  
    

    export default {
        name: "RecargoUpdate",
        
        components: { RecargoForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'recargo.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    id: this.item.id,
                    nombre: this.item.nombre,
                    recargo: this.item.recargo
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    RecargoProvider.updateRecargo(this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.recargoUpdate)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>
